import { render, staticRenderFns } from "./videoIPVDetails.vue?vue&type=template&id=665dee7b&scoped=true&"
import script from "./videoIPVDetails.vue?vue&type=script&lang=js&"
export * from "./videoIPVDetails.vue?vue&type=script&lang=js&"
import style0 from "./videoIPVDetails.vue?vue&type=style&index=0&id=665dee7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665dee7b",
  null
  
)

export default component.exports